var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "email-broadcast-filter-toolbar" },
    [
      _c("CommonFilterTool", {
        attrs: {
          "keep-state-on-query-params": false,
          "filter-meta": _vm.filterMetas,
          "label-formatter": _vm.filterLabelFormatter,
        },
        on: { "clear-all": _vm.clearAllFilters },
        model: {
          value: _vm.emailBroadcastFilter,
          callback: function ($$v) {
            _vm.emailBroadcastFilter = $$v
          },
          expression: "emailBroadcastFilter",
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "active-filters" },
        [
          _vm._l(_vm.emailBroadcastFilter, function (filter, index) {
            return _c(
              "div",
              { key: index, staticClass: "active-filter-group" },
              [
                _c(
                  "div",
                  {
                    staticClass: "filter-wrapper-preview",
                    on: {
                      click: function ($event) {
                        return _vm.openFilter(filter.name)
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "filter-value-text" }, [
                      _vm._v(
                        _vm._s(
                          _vm.filterLabelFormatter(
                            filter.name,
                            filter.filterValue
                          )
                        )
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "clear-active-filter",
                    on: {
                      click: function ($event) {
                        return _vm.removeFilter(filter.name)
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("close"),
                    ]),
                  ]
                ),
              ]
            )
          }),
          _vm._v(" "),
          _vm.emailBroadcastFilter.length > 1
            ? _c(
                "div",
                {
                  staticClass: "clear-active-filter",
                  on: { click: _vm.clearAllFilters },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("ticket.ticketFilterList.clearAll")) +
                      "\n        "
                  ),
                ]
              )
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }